module.exports = __webpack_public_path__ + "img/dragino_lt_relay_xxxx.cbf5f30b.png";